$(document).ready(function () {
    /* Select active menu */

    var address = window.location.pathname;
    first =address.split('/');
    first = first[1];

    if(address != '/'){
        $('.top').addClass('background');
    }

     if(address == '/') {
        $( ".page__menu > .page__menuLi" ).removeClass('active');
     } else {
        $( ".page__menu > .page__menuLi" ).each(function( index ) {
            if($(this).html().indexOf(address)>0) {
                $( ".page__menu > .page__menuLi.active" ).removeClass('active');
                $(this).addClass('active');
                  if ($(this).hasClass('.page__menuLi--dropdown')) {
                    $(this).find('ul li').each(function( index ) {
                        if($(this).html().indexOf(address) > 0) {
                            $(this).addClass('active');
                        }
                    });
                }
                first = null;
                return;
            } else if($(this).html().indexOf(first)>0) {
                $(this).addClass('active');
            }
        });
     }

    $('.page__menuLi.active').closest('.page__dropdown').show();


    /* next level menu */
    $('.dropdown-submenu a.test').on("click", function (e) {
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
    });


    var currentPathname = window.location.pathname;
    var currentHref = window.location.href;
    $('.menu__link').each(function () {
        if ($(this).attr("href") == currentPathname || $(this).attr("href") == currentHref) {
            $(this).parent().addClass('active');
            $(this).closest('.menu__li--dropdown').addClass('active');
        }
    })

    $(".products__carousel").owlCarousel({

        loop: false,
        smartSpeed: 250,
        rewind: true,
        nav: true,
        autoplay:true,
        autoplayTimeout:3000,
        navText:['<div class="owl__arrow owl__arrow--prev"></div>','<div class="owl__arrow owl__arrow--next"></div>'],
        responsive: {
            0: {
                items: 1,
                margin: 0,
                center: true,
                nav: true,

            },
            768: {
                items: 2,
                margin: 10,
            },

            1025: {
                items: 3,
                margin: 40,

            },
            1200: {
                items: 4,
                margin: 40,

            },
            1400: {
                items: 5,
                margin: 40,

            },
            1700: {
                items: 6,
                margin: 40,

            }

        }

    });

    // $(".relatedProducts__carousel").owlCarousel({
    //
    //     loop: false,
    //     smartSpeed: 500,
    //     rewind: true,
    //     nav: false,
    //     responsive: {
    //         0: {
    //             items: 1,
    //             margin: 0,
    //             center: true,
    //         },
    //         768: {
    //             items: 2,
    //             margin: 10,
    //         },
    //
    //         1025: {
    //             items: 3,
    //             margin: 40,
    //
    //         },
    //         1200: {
    //             items: 4,
    //             margin: 40,
    //
    //         }
    //
    //     }
    //
    // });

    $(".news__carousel").owlCarousel({
        autoplay:true,
        autoplayTimeout:3000,
        nav: true,
        navText:['<div class="owl__arrow owl__arrow--prev"></div>','<div class="owl__arrow owl__arrow--next"></div>'],
        loop: false,
        smartSpeed: 250,
        rewind: true,
        responsive: {
            0: {
                items: 1,
                nav: true,


            },
            768: {
                items: 2,
                margin: 30,
            },

            1025: {
                items: 3,
                margin: 40,

            },
            1200: {
                items: 3,
                margin: 40,

            },
            1400: {
                items: 3,
                margin: 40,

            },
            1700: {
                items: 4,
                margin: 40,

            }

        }

    });


    $(window).on('scroll', function () {
        var st = $(window).scrollTop();
        if (st > 0) {
            $('.top').addClass('active');
            $('.serviceBlock').fadeIn('fast');
        } else {
            $('.top').removeClass('active');
            $('.serviceBlock').fadeOut('fast');
        }

    });


    $('.newsletter__checkbox').click(function () {
        $(this).parent().find('.newsletter__checkbox-view').toggleClass('selected');
    })

    $('.newsletter__checkbox').each(function () {
        if ($(this).is(':checked')) {
            $(this).parent().find('.newsletter__checkbox-view').toggleClass('selected');
        }
    })

    $('.newsletter__more').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).parent().find('.newsletter__moreText').show();
    })



    $(document).on('click','.product__showMore', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).parent().find('.product__text').slideToggle();
    })




    $('.top__search').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.search').fadeToggle();
        $('.search__input').focus();
        if (screen.width <= 1024) {
            $('.menuButton').removeClass('active');
            $('.top').removeClass('open');
            $('.menu').hide();
            $('.top .service').hide();
        }
    })

    $('.lang__choice').on("click", function (e) {
        e.preventDefault();
        $(this).parent().find('.lang__list').toggle();
        $('.search').fadeOut('fast');
        $('.top__search').removeClass('active');
    })

    if (screen.width <= 1024) {
        $('.lang').mouseleave(function () {
            $('.lang__list').hide();
        })
    }


        //
        // $(document).on('click','.pageContactButton', function(e){
        //     e.preventDefault();
        //     $(this).toggleClass('active');
        //     $(this).parent().find('.pageContactMore').fadeToggle();
        // });
        // $(document).blur('.pageContactButton', function(e){
        //     e.preventDefault();
        //     $(this).toggleClass('active');
        //     $(this).parent().find('.pageContactMore').fadeToggle();
        // });



        if (screen.width > 1024) {

            $('.pageContactButton').on('click', function(e){
                e.preventDefault();
                $(this).toggleClass('active');
                $(this).parent().find('.pageContactMore').fadeToggle();
            });

            $('.pageContactButton').blur(function () {
                $(this).removeClass('active');
                $(this).parent().find('.pageContactMore').fadeOut();
            });
        }




});
//# sourceMappingURL=default.js.map
